export class InputHelper {
    public static debounce = (callback: Function, wait: number) => {
        let timeoutId: number = null;
        return (...args: any[]) => {
          window.clearTimeout(timeoutId);
          timeoutId = window.setTimeout(() => {
            callback.apply(null, args);
          }, wait);
        };
      }
}